export enum MediaType {
  Image,
  Video
}